/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InternalTransferModel { 
    internalTransferId?: number;
    customerNumber?: string | null;
    fromLocationId?: number;
    toLocationId?: number;
    statusId?: number;
    customerName?: string | null;
    fromLocationIdentifier?: string | null;
    toLocationIdentifier?: string | null;
    statusName?: string | null;
}

